"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSubscriptionOutput = instanceOfSubscriptionOutput;
exports.SubscriptionOutputFromJSON = SubscriptionOutputFromJSON;
exports.SubscriptionOutputFromJSONTyped = SubscriptionOutputFromJSONTyped;
exports.SubscriptionOutputToJSON = SubscriptionOutputToJSON;
var Metadata_1 = require("./Metadata");
var Subscription_1 = require("./Subscription");
/**
 * Check if a given object implements the SubscriptionOutput interface.
 */
function instanceOfSubscriptionOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function SubscriptionOutputFromJSON(json) {
    return SubscriptionOutputFromJSONTyped(json, false);
}
function SubscriptionOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(Subscription_1.SubscriptionFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function SubscriptionOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(Subscription_1.SubscriptionToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
